export const GLOBAL_QUERY_PARAMS = {
  RESET_PASSWORD_TOKEN: "reset_password_token"
};
